<template>
  <TableLayout class="menu-layout" :permissions="['system:com:comInfo']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="车场编号" prop="comId">
        <el-input v-model="searchForm.comId" v-trim placeholder="请输入车场编号" @keypress.enter.native="search"/>
      </el-form-item>
      <el-form-item label="车场名称" prop="companyName">
        <el-input v-model="searchForm.companyName" v-trim placeholder="请输入车场名称" />
        <!-- <el-select v-model="searchForm.companyName" placeholder="请选择车场" filterable >
          <el-option :label="item.name" :value="item.name" v-for="(item,i) in parkingList" :key="i"></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="车场类型">
        <el-select v-model="searchForm.sourceType" placeholder="请选择车场类型">
          <el-option label="网络相机车场" value="1"></el-option>
          <el-option label="第三方车场软件车场" value="2"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetNew">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        ref="table"
        v-loading="isWorking.search"
        :data="tableData.list"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        row-key="id"
        stripe
        height="60vh"
        default-expand-all
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" label="车场ID"></el-table-column>
        <el-table-column prop="companyName" label="车场名称" min-width="200px"></el-table-column>
        <el-table-column prop="parkingTotal" label="车位总数" min-width="80px"></el-table-column>
        <el-table-column prop="parkingType" label="车场类型" min-width="100px">
          <template slot-scope="{row}">{{row.sourceType == '1' ? '网络相机车场' : '第三方软件车场'}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px">
          <template slot-scope="{row}">{{$getTime(row.createTime)}}</template>
        </el-table-column>
        <el-table-column prop="mobile" label="停车场电话" min-width="100px"></el-table-column>
        <!-- <el-table-column label="操作" min-width="120" fixed="right" v-if="containPermissions(['system:orderAd:config']) && userInfo.roles.indexOf('admin') != -1">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-s-tools" @click="doadTypeSetShow(row)" v-permissions="['system:orderAd:config']">订单广告服务</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" min-width="460" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-s-tools" @click="setAd(row)">订单广告服务</el-button>
            <el-button type="text" icon="el-icon-s-tools" @click="setAd2(row)">弹窗广告服务配置</el-button>
            <el-button type="text" icon="el-icon-s-tools" v-show="isAdmin" @click="setAli(row)">支付宝广告设置</el-button>
            <el-button type="text" icon="el-icon-s-promotion" v-permissions="['system:orderAd:config']" @click="openQrJump(row)">微信小程序二维码跳转配置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      ></pagination>
    </template>

    <el-dialog title="订单广告服务配置" :visible.sync="dialogVisible"  width="30%">
      <el-switch v-model="value1" active-text="开启" @change="changStatu"></el-switch>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="弹窗广告服务配置" :visible.sync="dialogVisible2"  width="30%">
      <el-switch v-model="isOpenWindow" active-text="开启" @change="setIsOpenWindowFun"></el-switch>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设置广告类型 -->
    <el-dialog title="设置广告类型" :visible.sync="adTypeSetShow" height="600px" width="400px">
      <div v-show="!isAdmin">
        <el-select v-model="adType" placeholder="请选择广告类型">
          <el-option v-for="item in adTypeListData" :label="item.name" :value="item.type" :key="item.type" />
        </el-select>
      </div>
      <div v-show="isAdmin">
        <el-switch v-model="value1" active-text="开启" @change="changStatu" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adTypeSetShow = false">取 消</el-button>
        <el-button type="primary" @click="defaultAdType">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="支付宝广告设置" :visible.sync="aliTypeSetShow" height="600px" width="400px">
      <el-form ref="form" label-width="160px" v-show="isAdmin">

        <el-form-item label="支付宝停车助手">
          <el-switch v-model="isOpen" active-text="开启" />
        </el-form-item>
        <el-form-item label="跳转支付宝">
          <el-switch v-model="isJump" active-text="开启" />
        </el-form-item>
        <el-form-item label="支付宝广告">
          <el-switch v-model="isShow" active-text="开启" />
        </el-form-item>
        <el-form-item label="优惠券跳转广告">
          <el-switch v-model="type1" active-text="开启" />
        </el-form-item>
        <el-form-item label="艾之付券包购买">
          <el-switch v-model="type2" active-text="开启" />
        </el-form-item>
        <el-form-item label="简易广告">
          <el-switch v-model="type4" active-text="开启" />
        </el-form-item>
        <el-form-item label="跳转微信小程序支付">
          <el-switch v-model="type5" active-text="开启" />
        </el-form-item>
        <!-- <el-form-item label="支付宝主扫跳转支付宝停车助手">
          <el-switch v-model="type6" active-text="开启" />
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="aliTypeSetShow = false">取 消</el-button>
        <el-button type="primary" @click="defaultAliType">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="微信小程序二维码跳转配置" :visible.sync="qrJumpDialogVisible" width="560px">
      <div v-loading="qrJumpListLoading">
        <el-form label-width="100px">
          <el-form-item label="车场ID">{{ qrJumpPark.id }}</el-form-item>
          <el-form-item label="车场名称">{{ qrJumpPark.companyName }}</el-form-item>
        </el-form>
        <el-alert
          title="将当前车场符合条件的静态二维码同步到艾支付小程序跳转配置。车场需满足艾支付、跳转微信小程序支付等条件，由后端校验。"
          type="info"
          :closable="false"
          show-icon
        />
        <div class="qr-jump-list">
          <p class="qr-jump-result__title">已推送二维码（{{ qrJumpUrlList.length }}）</p>
          <div v-if="qrJumpUrlList.length" class="qr-jump-list__body">
            <div v-for="(url, index) in qrJumpUrlList" :key="index" class="qr-jump-list__item">
              <span class="qr-jump-list__index">{{ index + 1 }}.</span>
              <a :href="url" target="_blank" rel="noopener noreferrer">{{ url }}</a>
            </div>
          </div>
          <p v-else class="qr-jump-list__empty">暂无已推送的二维码链接</p>
        </div>
        <div v-if="qrJumpResult" class="qr-jump-result">
          <p class="qr-jump-result__title">{{ qrJumpResultType === 'add' ? '新增结果' : '删除结果' }}</p>
          <table class="qr-jump-result__table">
            <tr>
              <th>本地合格URL</th>
              <td>{{ displayQrJumpNum(qrJumpResult.localUrlSize) }}</td>
              <th>艾支付现有URL</th>
              <td>{{ displayQrJumpNum(qrJumpResult.remoteUrlSize) }}</td>
            </tr>
            <tr v-if="qrJumpResultType === 'add'">
              <th>已存在</th>
              <td>{{ displayQrJumpNum(qrJumpResult.existingUrlSize) }}</td>
              <th>应新增</th>
              <td>{{ displayQrJumpNum(qrJumpResult.pendingAddSize) }}</td>
            </tr>
            <tr v-if="qrJumpResultType === 'add'">
              <th>新增成功</th>
              <td>{{ displayQrJumpNum(qrJumpResult.successAddSize) }}</td>
              <th>新增失败</th>
              <td>{{ displayQrJumpNum(qrJumpResult.failedAddSize) }}</td>
            </tr>
            <tr v-if="qrJumpResultType === 'delete'">
              <th>应删除</th>
              <td>{{ displayQrJumpNum(qrJumpResult.pendingDeleteSize) }}</td>
              <th>删除成功</th>
              <td>{{ displayQrJumpNum(qrJumpResult.successDeleteSize) }}</td>
            </tr>
            <tr v-if="qrJumpResultType === 'delete'">
              <th>删除失败</th>
              <td>{{ displayQrJumpNum(qrJumpResult.failedDeleteSize) }}</td>
              <th>原本不存在</th>
              <td>{{ displayQrJumpNum(qrJumpResult.absentUrlSize) }}</td>
            </tr>
            <tr>
              <th>异常URL数</th>
              <td colspan="3">{{ qrJumpInvalidCount }}</td>
            </tr>
          </table>
          <el-alert
            v-if="qrJumpFailedBatches.length"
            class="qr-jump-result__batch"
            type="warning"
            :closable="false"
            :title="'失败批次：' + qrJumpFailedBatches.join('；')"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qrJumpDialogVisible = false">取 消</el-button>
        <el-button type="danger" :loading="qrJumpDeleting" :disabled="qrJumpAdding || qrJumpListLoading" @click="deleteWechatQrJumpFun">删除跳转</el-button>
        <el-button type="primary" :loading="qrJumpAdding" :disabled="qrJumpDeleting || qrJumpListLoading || qrJumpHasPushed" @click="addWechatQrJumpFun">新增跳转</el-button>
      </div>
    </el-dialog>
  </TableLayout>
</template>

<script>
import TableLayout from '@/layouts/TableLayout'
import BaseTable from '@/components/base/BaseTable'
import Pagination from '@/components/common/Pagination'
import { parkingList,getAllOpenComId ,comOpen,comClose, aliAdOpenOrClose, aliadinfo ,setIsOpenWindow, addWechatQrJump, deleteWechatQrJump, listWechatQrJump} from '@/api/parking/parking'
import { getAdType, AdTypeList} from "@/api/ad/oderAdUpLoad";
import { updateById } from '@/api/tenant/tenant'
import { mapState } from 'vuex'
export default {
  name: 'SystemMenu',
  extends: BaseTable,
  components: { TableLayout, Pagination},
  data () {
    return {
      isOpenWindow: false,
      aliTypeSetShow: false,
      isAdmin: false,
      adTypeSetShow: false,
      value1:false,
      dialogVisible:false,
      type1: false,
      type2: false,
      type3: false,
      type4: false,
      type5: false,
      type6: false,
      // 搜索时间范围
      searchDateRange: [],
      // 是否正在处理中
      isWorking: {
        sort: false
      },
      // 搜索
      searchForm: {
        comId: '',
        companyName: '',
        sourceType: '',
      },
      parkingList:[],
      OpenComId:[],
      checkPark:{},
      adTypeListData: [],
      adType: '',
      adTenant: {},
      isOpen: true,
      isJump: true,
      isShow: true,
      dialogVisible2: false,
      checkPark2: {},
      qrJumpDialogVisible: false,
      qrJumpPark: {},
      qrJumpResult: null,
      qrJumpResultType: '',
      qrJumpAdding: false,
      qrJumpDeleting: false,
      qrJumpListLoading: false,
      qrJumpUrlList: []
    }
  },
  mounted(){
    this.getParkingListFuc();
    this.getAllOpenComIdFun();
    if (this.userInfo.roles.indexOf("admin") != -1) {
      this.isAdmin = true
    }
  },
  computed: {
    ...mapState(['userInfo']),
    qrJumpInvalidCount () {
      return this.qrJumpResult && this.qrJumpResult.invalidUrls
        ? this.qrJumpResult.invalidUrls.length
        : 0
    },
    qrJumpFailedBatches () {
      return this.qrJumpResult && this.qrJumpResult.failedBatches
        ? this.qrJumpResult.failedBatches
        : []
    },
    qrJumpHasPushed () {
      return this.qrJumpUrlList.length > 0
    }
  },
  methods: {
    doadTypeSetShow(row) {
      console.log(this.userInfo)
      this.adTenant = row
      this.AdTypeListFun()
      getAdType(row.id).then(res=>{
        this.adType = res === null ? 'IST' : res
      })
    },
    yyUpdateById() {
      let data = {
        adType: this.adType,
        code: this.adTenant.code,
        createTime: this.adTenant.createTime,
        managerUserId: this.userInfo.id,
        id: this.adTenant.id,
        name: this.adTenant.name,
        updateTime: this.adTenant.updateTime,
      }
      updateById(data).then(res=>{
        this.adTypeSetShow = false;
        this.$message({ message: '操作成功', type: 'success'});
        this.search()
      }).catch(e=>{
        this.adTypeSetShow = false;
        this.$message.error(e);
        
      })
    },
    // 设置默认广告
    defaultAdType() {
      // admin层
      if (this.isAdmin) {

      } else {
        this.yyUpdateById()
      }
      
    },
    // 设置弹窗广告
    setIsOpenWindowFun() {
      let data = {
        comId: this.checkPark2.id,
        isOpenWindow: this.isOpenWindow ? 1 : 0
      }
      setIsOpenWindow(data).then(res=>{
        this.$tip.apiSuccess('设置成功')
        this.search()
      })
    },
    // 获取所有广告类型
    AdTypeListFun() {
      this.adTypeListData = []
       AdTypeList().then(res=>{
        this.adTypeListData = res
        this.adTypeSetShow = true
      })
    },
    changStatu(statu){
      let data = {
        comIds:[this.checkPark.id],
        tenantId:this.userInfo.id
      }
      if(statu){
        comOpen(data).then(res=>{
          this.$tip.apiSuccess('设置成功')
          this.getAllOpenComIdFun()
        }).catch(e => {
          this.$tip.apiFailed(e)
        })
      }else{
        comClose(data).then(res=>{
          this.$tip.apiSuccess('设置成功')
          this.getAllOpenComIdFun()
        }).catch(e => {
          this.$tip.apiFailed(e)
        })
      }
    },
    setAd2(row){
      this.checkPark2 = row;
      this.isOpenWindow = row.isOpenWindow ? true : false
      this.dialogVisible2 = true

    },
    setAd(row){
      this.checkPark = row;
      if(this.OpenComId.indexOf(row.id) != -1){
        this.value1 = true;
      }else{
        this.value1 = false;
      }
      this.dialogVisible = true

    },
    getAllOpenComIdFun(){
      getAllOpenComId().then(res=>{
        this.OpenComId = res;
      })
    },
    setAli(row){
      this.checkPark = row;
      aliadinfo({comId: row.id})
        .then(records => {
          this.isOpen = records.isOpen ? true : false
          this.isJump = records.isJump ? true : false
          this.isShow = records.isShow ? true : false
          this.aliTypeSetShow = true
          this.type1 = records.type1 ? true : false
          this.type2 = records.type2 ? true : false
          this.type4 =  records.type4 ? true : false
          this.type5 =  records.type5 ? true : false
          this.type6 =  records.type6 ? true : false
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          
        })
      

    },
    openQrJump(row) {
      this.qrJumpPark = row || {}
      this.qrJumpResult = null
      this.qrJumpResultType = ''
      this.qrJumpUrlList = []
      this.qrJumpDialogVisible = true
      this.fetchWechatQrJumpList()
    },
    fetchWechatQrJumpList() {
      if (!this.qrJumpPark.id) {
        return
      }
      this.qrJumpListLoading = true
      listWechatQrJump({ comId: this.qrJumpPark.id })
        .then(data => {
          this.qrJumpUrlList = Array.isArray(data) ? data : []
        })
        .catch(e => {
          this.qrJumpUrlList = []
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.qrJumpListLoading = false
        })
    },
    displayQrJumpNum(value) {
      return value == null ? 0 : value
    },
    addWechatQrJumpFun() {
      if (!this.qrJumpPark.id) {
        this.$message.warning('请选择车场')
        return
      }
      if (this.qrJumpHasPushed) {
        this.$message.warning('该车场已推送二维码，无需重复新增')
        return
      }
      this.qrJumpAdding = true
      addWechatQrJump({ comId: this.qrJumpPark.id })
        .then(data => {
          this.qrJumpResult = data || {}
          this.qrJumpResultType = 'add'
          const pending = this.displayQrJumpNum(this.qrJumpResult.pendingAddSize)
          const failed = this.displayQrJumpNum(this.qrJumpResult.failedAddSize)
          const success = this.displayQrJumpNum(this.qrJumpResult.successAddSize)
          if (pending === 0) {
            this.$tip.apiSuccess('无需新增')
          } else if (failed === 0) {
            this.$tip.apiSuccess('操作完成')
          } else {
            let msg = `部分失败：成功 ${success} 条，失败 ${failed} 条，请重试`
            if (this.qrJumpInvalidCount > 0) {
              msg += `（过滤异常链接 ${this.qrJumpInvalidCount} 条）`
            }
            this.$message.warning(msg)
          }
          this.fetchWechatQrJumpList()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.qrJumpAdding = false
        })
    },
    deleteWechatQrJumpFun() {
      if (!this.qrJumpPark.id) {
        this.$message.warning('请选择车场')
        return
      }
      this.$confirm('确认删除该车场已推送至艾支付的二维码跳转配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.qrJumpDeleting = true
        return deleteWechatQrJump({ comId: this.qrJumpPark.id })
      }).then(data => {
        this.qrJumpResult = data || {}
        this.qrJumpResultType = 'delete'
        const pending = this.displayQrJumpNum(this.qrJumpResult.pendingDeleteSize)
        const failed = this.displayQrJumpNum(this.qrJumpResult.failedDeleteSize)
        const success = this.displayQrJumpNum(this.qrJumpResult.successDeleteSize)
        if (pending === 0) {
          this.$tip.apiSuccess('无需删除')
        } else if (failed === 0) {
          this.$tip.apiSuccess('操作完成')
        } else {
          this.$message.warning(`部分失败：成功 ${success} 条，失败 ${failed} 条，请重试`)
        }
        this.fetchWechatQrJumpList()
      }).catch(e => {
        if (!e || e === 'cancel' || e === 'close') {
          return
        }
        this.$tip.apiFailed(e)
      }).finally(() => {
        this.qrJumpDeleting = false
      })
    },
    defaultAliType() {
      let obj = {
        comId: this.checkPark.id,
        enable: this.isOpen ? 1 : 0,
        isJump: this.isJump ? 1 : 0,
        isShow: this.isShow ? 1 : 0,
        type1: this.type1 ? 1 : 0,
        type2: this.type2 ? 1 : 0,
        type3: this.type3 ? 1 : 0,
        type4: this.type4 ? 1 : 0,
        type5: this.type5 ? 1 : 0,
        type6: this.type6 ? 1 : 0
      }
      console.log('aliAdOpenOrClose', obj)
      aliAdOpenOrClose(obj)
        .then(records => {
          this.$tip.apiSuccess('设置成功')
          this.aliTypeSetShow = false
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          
        })
      
    },
    // 时间搜索范围变化
    handleSearchTimeChange (value) {
      this.searchForm.createTimeStart = null
      this.searchForm.createTimeEnd = null
      if (value != null) {
        this.searchForm.createTimeStart = value[0] / 1000
        this.searchForm.createTimeEnd = value[1] / 1000
      }
      this.search()
    },
    getParkingListFuc(){
      parkingList()
        .then(records => {
          this.parkingList = records
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          
        })
    },
    //重置
    resetNew(){
      this.searchForm = {
        comId: '',
        companyName: '',
        sourceType: '',
      }
      this.search()
    },
  },
  created () {
    this.config({
      module: '菜单',
      api: '/parking/parking',
      sorts: [{
        property: 'create_time',
        direction: 'DESC'
      }]
      
    })
    this.search()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
.menu-layout {
  /deep/ .table-content {
    margin-top: 0;
  }
}
// 图标列
.table-column-icon {
  // element-ui图标
  i {
    background-color: $primary-color;
    opacity: 0.72;
    font-size: 20px;
    color: #fff;
    padding: 4px;
    border-radius: 50%;
  }
  // 自定义图标
  [class^="yunying-icon-"] {
    width: 20px;
    height: 20px;
    background-size: 16px;
    vertical-align: middle;
  }
}
.qr-jump-list {
  margin-top: 16px;
}
.qr-jump-list__body {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 10px;
  background: #fafafa;
}
.qr-jump-list__item {
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
  word-break: break-all;
  font-size: 13px;
  & + & {
    margin-top: 6px;
  }
  a {
    color: #409eff;
  }
}
.qr-jump-list__index {
  flex-shrink: 0;
  margin-right: 4px;
  color: #909399;
}
.qr-jump-list__empty {
  margin: 0;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
}
.qr-jump-result {
  margin-top: 16px;
}
.qr-jump-result__title {
  margin: 0 0 8px;
  font-weight: 600;
  color: #303133;
}
.qr-jump-result__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.qr-jump-result__table th,
.qr-jump-result__table td {
  border: 1px solid #ebeef5;
  padding: 8px 10px;
}
.qr-jump-result__table th {
  width: 110px;
  background: #f5f7fa;
  color: #909399;
  font-weight: 500;
  text-align: left;
}
.qr-jump-result__batch {
  margin-top: 10px;
}
</style>
